import { Menu } from "./Menu";
import { Root } from "./Root";
import { TopNavSearch } from "./TopNavSearch";

export * from "./TopNavLink";
export * from "./TopNavSearch";
export * from "./TopNavWrapper";

export const TopNav = Object.assign(Root, {
  Menu,
  Search: TopNavSearch,
});
